import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 20px;
  flex: 1;
  border-top: 1px solid #c0c0c0;
  margin-top: 22px;
`;

export const Text = styled.p`
  font-family: Inter;
  font-style: normal;
  color: #333;
  font-weight: 400;
  line-height: 19px;
  padding: 0 16px 0 16px;
  align-self: center;
  margin-top: -30px;
  font-size: 12px;
  background-color: #fff;
`;
